const count = (items) => Array.isArray(items) ? items.length : 0;
export const isSoftwareSkill = (skill = {}) => skill.itemKind ? skill.itemKind === 'tool' : /logiciel|cao|dao|bim/i.test(skill.category || '') || /autocad|caneco|dialux|revit|office|excel/i.test(skill.name || '');
export const resolveCvScore = (data = {}, options = {}) => {
  let score = Math.ceil((data.presentation?.cvSummary?.length || 0) / 350);
  score += (data.experiences || []).reduce((total, experience) => total + 3 + Math.ceil((experience.summary?.length || 0) / 250) + Math.min(count(experience.missions), 5), 0);
  score += count(data.educations) + count(data.trainings);
  score += Math.ceil(count(data.skills) / 4) + Math.ceil(count(data.certifications) / 3);
  score += options.showReferences === false ? 0 : count(data.references) * 2;
  score += options.showPhoto !== false && data.employee?.photoUrl ? 1 : 0;
  return score;
};
export const resolveCvLayout = (data = {}, options = {}) => resolveCvScore(data, options) <= 18 ? 'single-page' : 'two-pages';
const limit = (items = []) => ({ shown: items, hidden: 0 });
export const composeCvContent = (data = {}, options = {}) => {
  const layout = resolveCvLayout(data, options);
  const score = resolveCvScore(data, options);
  const softwareSkills = (data.skills || []).filter(isSoftwareSkill);
  const coreSkills = (data.skills || []).filter((skill) => !isSoftwareSkill(skill));
  const experiences = limit(data.experiences);
  const education = limit(data.educations);
  const trainings = limit((data.trainings || []).filter((item) => item.showInCv !== false));
  const core = limit(coreSkills);
  const software = limit(softwareSkills);
  const certifications = limit(data.certifications);
  const references = limit(options.showReferences === false ? [] : data.references);
  const hidden = { experiences: experiences.hidden, skills: core.hidden + software.hidden, education: education.hidden, trainings: trainings.hidden, certifications: certifications.hidden, references: references.hidden };
  const hiddenTotal = Object.values(hidden).reduce((sum, value) => sum + value, 0);
  const warnings = [];
  if (!data.employee?.photoUrl && options.showPhoto !== false) warnings.push('Photo absente');
  if ((data.presentation?.cvSummary?.length || 0) > 650) warnings.push('Présentation supérieure à 650 caractères');
  return { layout, score, density: score <= 13 ? 'faible' : score <= 32 ? 'correcte' : 'élevée', hidden, hiddenTotal, warnings, experiences: experiences.shown, education: education.shown, trainings: trainings.shown, coreSkills: core.shown, softwareSkills: software.shown, certifications: certifications.shown, references: references.shown };
};
